import React from 'react'
import { PropertyForm } from '../components/survey'
import useMobileLayout from '../hooks/useMobileLayout'
import MobileNewSurvey from '../components/mobile/MobileNewSurvey'

export default function NewSurveyPage() {
  const isMobile = useMobileLayout()

  if (isMobile) {
    return <MobileNewSurvey />
  }

  return (
    <div className="max-w-2xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-slate-900">New Property Survey</h1>
        <p className="text-slate-500 mt-1">
          Enter the property details to start a new survey
        </p>
      </div>
      <PropertyForm />
    </div>
  )
}
